<template>
  <div>
    <a @click="jump_order(storeItem.id, storeItem.storename)" class="storeList flex_center" v-for="(storeItem,storeIndex) in storeList" :key="storeIndex">
      <div class="storeList__img"><img :src="storeItem.logo" alt=""></div>
      <div class="storeList__content">
        <div class="flex storeList__line">
          <div>{{storeItem.storename}}</div>
          <div class="storeList__distance" v-if="storeItem.juli">
            <span class="iconfont icon-loc-s col_00A29A"></span>
            <p >{{storeItem.juli}}</p>
          </div>
        </div>
        <div class="col_999 fs_12 storeList__subtitle">
          <p>地址：{{storeItem.address}}</p>
          <p>电话：{{storeItem.tel}}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: "selectStore",
    data(){
      return{
        service_id:0,
        tech_id:0,
        member_total:1,
        //门店列表
        storeList: [],
        distanceNum:5
      }
    },
    methods:{
       get_store(){
          this.wx.wxgetlocation(result=>{    
            this.axios({
              url: this.api.order.select_store_list,
              data:{
                  'lat':result.latitude,
                  'lng':result.longitude,
                  'service_id':this.service_id,
                  'tech_id':this.tech_id,
                  'member_total':this.member_total,   
              }
              }).then((res) => {
                if (res.error === 0) {
                  this.storeList  = res.store  
                }

            })
          },()=>{
            this.axios({
              url: this.api.order.select_store_list,
              data:{
                  'lat':0,
                  'lng':0,
                  'service_id':this.service_id,
                  'tech_id':this.tech_id,
                  'member_total':this.member_total,   
              }
              }).then((res) => {
                if (res.error === 0) {
                  this.storeList  = res.store  
                }

            })
         });        

       },
       jump_order(store_id){
          var jump_data = {
            'service_id':this.service_id,
            'tech_id':this.tech_id,
            'store_id':store_id,
            
          }
          //修改缓存
          var order  = JSON.parse(sessionStorage.getItem("order"));
          console.log(order);
          order['store_id'] = store_id;
          sessionStorage.setItem('order',JSON.stringify(order));
          this.$router.push({path:'bookOrder',query:jump_data});
       }
    },
     created(){
       this.service_id = this.$route.query.service_id;
       this.tech_id  =this.$route.query.tech_id;
       this.member_total = this.$route.query.member_total;
       this.get_store();
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  .storeList__line{
    margin-bottom: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/selectStore.vue